import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { Button } from "@mui/material";
import { useOmnisearchActions, useOmnisearchState } from "hooks/omnisearch-v2";

const IGNORED_KEY = "ignored";
const TRUE = "true";

/** True when the omnisearch string is scoped to ignored:true. */
function isIgnoredOn(omnisearch: string): boolean {
  return /(^|\s)ignored:true(\s|$)/i.test(omnisearch);
}

/**
 * Staff toggle that flips the rejections grid + stat cards to show ONLY findings
 * on ignored (not-under-contract) facilities, which are hidden by default. Driven
 * by the `ignored:true` omnisearch token so it composes with deep links.
 */
export function IgnoredFindingsToggle() {
  const { editKeyValues, removeKey } = useOmnisearchActions();
  const { omnisearch } = useOmnisearchState();
  const on = isIgnoredOn(omnisearch);

  const handleToggle = () => {
    if (on) {
      removeKey(IGNORED_KEY);
    } else {
      editKeyValues([[IGNORED_KEY, TRUE]]);
    }
  };

  return (
    <Button
      size="small"
      variant={on ? "contained" : "outlined"}
      aria-pressed={on}
      startIcon={<VisibilityOff />}
      sx={{ px: 2 }}
      onClick={handleToggle}
      aria-label="Show ignored facilities"
    >
      Ignored
    </Button>
  );
}
